import React, { useEffect, useRef } from 'react';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
export default function CkEditorText({htmlData, onChangeData, onBlurData, disabled=false,onFocusData,placeholder}){
  const isFirstLoad = useRef(true);
  useEffect(()=>{
    isFirstLoad.current = false;
  },[])
  return(
    <div className="ck-content">
      <CKEditor
        editor={ ClassicEditor }
        data={htmlData}
        disabled={disabled}
        config={{removePlugins:['MediaEmbed', 'ImageUpload', 'Indent'],placeholder: placeholder || "Please Enter..."}}
        onInit={ editor => {
            // You can store the "editor" and use when it is needed.

        }}
        onChange={(event, editor) => {
          const data = editor.getData();
          if (isFirstLoad.current) return; // Skip first auto-change
          if (typeof onChangeData === 'function') onChangeData(data);
        }}
        onBlur={ ( event, editor ) => {
          if (typeof onBlurData === 'function') {
            const data = editor.getData();
            onBlurData(data);
          }
        }}
        onFocus={ ( event, editor ) => {
          if (typeof onFocusData === 'function') {
            const data = editor.getData();
            onFocusData(data);
          }
        }}
      />
    </div>
  )
}
